import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CategoryService, ICategoryService } from './services/api/category';
import { ILocalityService, LocalityService } from './services/api/locality';
import { IMapRatingService, IMapService, MapRatingService, MapService } from './services/api/map';
import { IRiskService, RiskService } from './services/api/risk';
import { HelpDataService, IHelpDataService, IRisksDataMapService, RisksDataMapService } from './services/core';
import { CookieManagerService, ICookieManagerService } from './services/ui';

export function provideCoreServices(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ICategoryService, useClass: CategoryService },
    { provide: ILocalityService, useClass: LocalityService },
    { provide: IMapRatingService, useClass: MapRatingService },
    { provide: IMapService, useClass: MapService },
    { provide: IRiskService, useClass: RiskService },
    { provide: IHelpDataService, useClass: HelpDataService },
    { provide: IRisksDataMapService, useClass: RisksDataMapService },
    { provide: ICookieManagerService, useClass: CookieManagerService }
  ]);
}
